<template>
  <modal
    name="inputModal"
    adaptive
    :pivotY="0.1"
    :width="360"
    height="auto"
    classes="wf-shadow-xl wf-rounded-lg wf-bg-white wf-px-4 wf-pt-4"
    @before-open="beforeOpen"
    @closed="closed"
  >
    <div class="wf-flex wf-flex-col wf-h-full">
      <div class="wf-flex wf-flex-wrap  wf-items-center">
        <div class="wf-flex-1">
          <div>
            <label for="name" class="wf-font-semibold wf-text-gray-600 wf-text-xs wf-uppercase">Name</label>
            <input
              id="name"
              type="text"
              :value="content.name"
              @input="updateInputName"
              class="wf-mt-1 focus:wf-outline-none wf-bg-gray-200 wf-h-10 wf-text-gray-700 wf-rounded-md wf-text-sm wf-px-2 wf-w-full"
            />
          </div>
          <div class="wf-mt-4">
            <label for="type" class="wf-font-semibold wf-text-gray-600 wf-text-xs wf-uppercase">Type</label>
            <select
              id="type"
              :value="content.type"
              @change="updateInputType"
              class="wf-mt-1 focus:wf-outline-none wf-bg-gray-200 wf-h-10 wf-text-gray-700 wf-rounded-md wf-text-sm wf-px-2 wf-w-full"
            >
              <option>text</option>
              <option>email</option>
              <option>number</option>
              <option>select</option>
              <option>checkbox</option>
              <option>radio</option>
              <option>date</option>
              <option>time</option>
              <option>textarea</option>
            </select>
          </div>
          <div class="wf-flex wf-mt-4 wf-justify-end">
            <label for="target" class="wf-flex wf-items-center">
              <input @change="toggleInputRequired" :checked="content.required" id="target" type="checkbox">
              <span class="wf-text-gray-600 wf-inline-block wf-ml-2 wf-text-xs wf-font-semibold wf-uppercase">required</span>
            </label>
          </div>
          <div class="wf-mt-4"  v-show="typeHasOptions">
            <label class="wf-font-semibold wf-text-gray-600 wf-text-xs wf-uppercase">Options</label>
          </div>
          <div class="wf-h-64 wf-overflow-scroll wf-rounded wf-border" v-show="typeHasOptions">
            <div class="wf-p-2">
              <div class="wf-flex wf-flex-wrap wf-items-stretch wf--mx-2">
                <template v-for="(option, index) in content.options">
                  <div :key="`close_${option.value}_${index}`" class="wf-flex wf-h-full wf-items-end wf-w-2/12 wf-px-2">
                    <button @click.prevent="removeOption(index)" class="wf-rounded-md wf-text wf-border wf-border-gray-300 wf-leading-none wf-h-8 wf-w-8 wf-mt-6 ">&times;</button>  
                  </div>
                  
                  <div :key="`value_${option.value}_${index}`" class="wf-w-5/12 wf-px-2">
                    <span class="wf-text-xs">value</span>
                    <input
                      @input="updateOption(index, null, $event.target.value)"
                      :value="option.value"
                      type="text"
                      class="focus:wf-outline-none wf-bg-gray-200 wf-h-8 wf-text-gray-700 wf-rounded-md wf-text-xs wf-px-2 wf-w-full"
                    >
                  </div>
                  <div :key="`text_${option.text}_${index}`" class="wf-w-5/12 wf-px-2">
                    <span class="wf-text-xs">text</span>
                    <input
                      @input="updateOption(index, $event.target.value, null)"
                      :value="option.text"
                      type="text"
                      class="focus:wf-outline-none wf-bg-gray-200 wf-h-8 wf-text-gray-700 wf-rounded-md wf-text-xs wf-px-2 wf-w-full"
                    >
                  </div>
                </template>
                <div class="wf-w-full wf-px-2 wf-mt-4">
                  <button @click.prevent="addOption" class="wf-text-center wf-w-full wf-border wf-border-gray-500 wf-rounded-md wf-text-gray-500 wf-border-dashed wf-h-10 wf-text-xs wf-uppercase wf-font-semibold">
                    <i class="fas fa-plus wf-mr-2"></i> add option
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="wf-mt-4 wf-pb-4">
        <button
          class="wf-text-xs wf-w-full wf-bg-blue-300 wf-uppercase wf-w-32 wf-h-10 wf-rounded-md hover:wf-bg-blue-200 wf-text-blue-800 hover:wf-text-blue-700 wf-font-bold"
          @click.prevent="$modal.hide('inputModal')"
        >Close</button>
      </div>
    </div>
  </modal>
</template>

<script>
  import _ from 'lodash'
  import ArrayManipulation from  '../mixins/ArrayManipulation'
  export default {
    mixins: [ArrayManipulation],
    data() {
      return {
        formElement: null,
        inputElement: null,
        module: null,
        parentModule: null
      }
    },
    computed: {
      typeHasOptions() {
        return this.content.type == 'select' || this.content.type == 'radio'
      },
      form() {
        if (! this.formElement) {
          return null
        }
        return this.$store.getters[`${this.module}/elements`](this.formElement, this.parentModule)
      },
      content() {
        if (! this.form) {
          return {}
        }
        return this.form.content.rows[this.inputElement.formRow].columns[this.inputElement.formColumn].components[this.inputElement.formInput].content
      }
    },
    methods: {
      beforeOpen(event) {
        this.module = event.params.module
        this.formElement = event.params.formElement
        this.inputElement = event.params.inputElement
        this.parentModule = event.params.parentModule
      },
      closed() {
        this.resetForm()
      },
      resetForm() {
        this.formElement = null
        this.module = null
        this.inputElement = null
      },
      updateFormInput() {
        this.$modal.hide('inputModal')
      },
      updateInputType(event) {
        let options = []
        if (event.target.value == 'select' || event.target.value == 'radio') {
          options = [{value: 'value', text: 'text'}]
        }
        this.updateElement({type: event.target.value, options: options})
      },
      updateInputName: _.debounce(function (event) {
        this.updateElement({name: event.target.value})
      }, 1000),
      toggleInputRequired(event) {
        this.updateElement({required: event.target.checked})
      },
      removeOption(optionIndex) {
        let options = [...this.content.options].filter((option, index) => index != optionIndex)
        this.updateElement({options: options})
      },
      addOption() {
        let options = [...this.content.options, {value: 'lorem', text: 'ipsum'}]
        this.updateElement({options: options})
      },
      updateOption: _.debounce(function (optionIndex, newText, newValue) {
        let newOption = this.content.options[optionIndex]
        if (newText) {
          newOption = {...newOption, text: newText}
        }
        if (newValue) {
          newOption = {...newOption, value: newValue}
        }
        let options = this.content.options.map((option, index) =>  index != optionIndex ? option : newOption)
        this.updateElement({options: options})
      }, 1000),
      updateElement(newContent) {
        let content = {...this.content, ...newContent}
        let rows = this.form.content.rows.map((formRow, rowIndex) => {
          if (rowIndex != this.inputElement.formRow) {
            return formRow
          }
          let columns = formRow.columns.map((formColumn, columnIndex) => {
            if (columnIndex != this.inputElement.formColumn) {
              return formColumn
            }
            let components = formColumn.components.map((formComponent, componentIndex) => {
              if (componentIndex != this.inputElement.formInput) {
                return formComponent
              }
              return {...formComponent, content: content}
            })
            return {...formColumn, components: components}
          })
          return {...formRow, columns: columns}
        })
        this.addToObject(this.module, {rows: rows}, 'content', null, this.formElement, true, this.parentModule)
      }
    }
  }
</script>